import dayjs from 'dayjs';
import { getStartOfWeek } from '../get-start-of-week/get-start-of-week.js';

function getWeekdaysNames(locale) {
  var firstDayOfWeek = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "monday";
  var format = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "dd";
  var names = [];
  var date = getStartOfWeek(new Date(), firstDayOfWeek);

  for (var i = 0; i < 7; i += 1) {
    names.push(dayjs(date).locale(locale).format(format));
    date.setDate(date.getDate() + 1);
  }

  return names;
}

export { getWeekdaysNames };